import WestIcon from '@mui/icons-material/West';
import { useEffect, useRef } from 'react';
const FallBackUi = ({ resetErrorBoundary }) => {
  const outsideRef = useRef();
  function ClickOutSide(e) {
    if (outsideRef?.current && !outsideRef?.current?.contains(e?.target)) {
      resetErrorBoundary();
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', ClickOutSide);
    return () => {
      document.addEventListener('mousedown', ClickOutSide);
    };
  }, []);
  return (
    <div className='grid place-content-center h-full' ref={outsideRef}>
      <div className='text-center'>
        <h2 style={{ color: '#1e293b', marginBottom: '0.5rem' }}>
          Something went wrong
        </h2>
        <p style={{ color: '#64748b', marginBottom: '2rem' }}>
          We're sorry for the inconvenience
        </p>
        <button
          onClick={resetErrorBoundary}
          style={{
            padding: '12px 24px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          <WestIcon></WestIcon>Back
        </button>
      </div>
    </div>
  );
};
export default FallBackUi;
